<template>
    <div class="index">
        <div class="out_box">
            <div class="header_title u-f u-ac">
                <div @click="backpage" class="icon iconfont icon-a-zuojiantouzhixiangzuojiantou backbtn"></div>申请入驻
            </div>
            <div class="lc_body">
                <div class="rzwidth" v-for="(s,index) in chooseinv" :key="index" @click="selectinv(s,index)">
                    <img v-if="activeSelect_inv!=index" :src="s.img" alt="" class="rzimg">
                    <img v-else :src="s.imged" alt="" class="rzimg">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                chooseinv: [{
                        id: 1,
                        img: require('../../assets/imgs/rz/ys2.png'),
                        imged: require('../../assets/imgs/rz/ys.png'),
                    },
                    {
                        id: 2,
                        img: require('../../assets/imgs/rz/dr2.png'),
                        imged: require('../../assets/imgs/rz/dr.png'),
                    },
                    {
                        id: 3,
                        img: require('../../assets/imgs/rz/hos2.png'),
                        imged: require('../../assets/imgs/rz/hos.png'),
                    },
                ],
                activeSelect_inv:2,
                activeSelect_inv_ID:3
            }
        },
        mounted() {
            this.getsf()
        },
        methods: {


            nextstep(formName) {


            },

            pevstep() {
                this.stepindex--
            },
            backpage() {
                this.$router.go(-1)
            },
            selectinv(s, i) {
				if (i != 2) return this.$message('暂未开放！')
				this.activeSelect_inv = i
				this.activeSelect_inv_ID = s.id
                this.$router.push('/register')
			}

        }
    }
</script>

<style lang="scss" scoped>
    #app {
        height: 100%;
    }

    .index {
       background-image: url('../../assets/imgs/login_bgimg.jpg');
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
        height: 100vh;
        // height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: auto;

        .out_box {
            background-color: #fff;
            border-radius: 8px;

            .header_title {
                padding: 20px 25px;
                font-size: 20px;
                font-weight: 600;

                .backbtn {
                    font-size: 25px;
                    margin-right: 15px;
                    cursor: pointer;
                }

            }

            .lc_body {
                min-height: 550px;
                width: 500px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .rzwidth {
                    width: 100%;
                }

                .rzimg {
                    width: 100%;
                }
            }
        }
    }
</style>